import { render, staticRenderFns } from "./CohortListAddNew.vue?vue&type=template&id=73949be8&scoped=true&"
import script from "./CohortListAddNew.vue?vue&type=script&lang=js&"
export * from "./CohortListAddNew.vue?vue&type=script&lang=js&"
import style0 from "./CohortListAddNew.vue?vue&type=style&index=0&id=73949be8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73949be8",
  null
  
)

export default component.exports